var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankProductAndServicePromo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3116.000000, -1167.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank-Product-and-Service/Promo",
    transform: "translate(3116.000000, 1167.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.64,25.87 L32,22.66 C31.72,21.79 30.95,21.21 30.07,21.21 L30.04,21.21 L26.18,21.26 L24.57,16 C24.51,16 24.44,16 24.38,16.02 C23.57,16.09 22.87,16.65 22.63,17.46 L21.46,21.26 L16.1,21.21 C15.83,22.08 16.12,23.03 16.86,23.57 L20,25.87 L19.96,26 L18.16,31.6 C18.51,31.86 18.94,32 19.35,32 C19.78,32 20.2,31.86 20.57,31.59 L23.82,28.73 L28.14,32 C28.86,31.46 29.15,30.51 28.87,29.65 L27.64,25.87 Z M16.25,8.12 L20.31,8.12 L20.31,4.06 L16.25,4.06 L16.25,8.12 Z M8.94,8.12 L13,8.12 L13,4.06 L8.94,4.06 L8.94,8.12 Z M8.94,15.44 L13,15.44 L13,11.38 L8.94,11.38 L8.94,15.44 Z M24.38,2.44 L24.38,14.01 C22.67,14.08 21.21,15.22 20.71,16.88 L19.99,19.24 L16.12,19.21 L14.64,19.2 L14.19,20.61 C13.66,22.3 14.25,24.14 15.67,25.18 L16.79,26 L7.31,26 C5.97,26 4.88,24.91 4.88,23.56 L4.88,0 L21.94,0 C23.28,0 24.38,1.09 24.38,2.44 L24.38,2.44 Z M4.875,26 L2.437,26 C1.091,26 0,24.909 0,23.562 L0,2.437 L2.437,2.437 L2.437,23.562 C2.437,24.909 3.529,26 4.875,26 L4.875,26 Z",
    id: 144
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankProductAndServicePromo);
export default __webpack_public_path__ + "static/media/bank-product-and-service-promo.1b34692f.svg";
export { ForwardRef as ReactComponent };